"use strict";

var _classCallCheck = require("/home/bacancy/Desktop/incidentgo/project/incident-code-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/bacancy/Desktop/incidentgo/project/incident-code-web/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * the config uses cross apps, the values are default, but can be change via db
 * null is require to do reflect
 */

var Config =
/*#__PURE__*/
function () {
  function Config() {
    _classCallCheck(this, Config);

    this.remoteLogger = null;
    this.contactLimit = null;
    this.incidentDurationMs = null;
    this.locationUpdateInterval = null;
    this.defaultNotificationDistance = null;
    this.maxNotificationDistance = null;
    this.maxRecordDuration = null;
    this.fetchInterval = null;
    this.incidentCategories = null;
  }

  _createClass(Config, [{
    key: "getIncidentCategory",
    value: function getIncidentCategory(category) {
      var result;

      if (this.incidentCategories != null) {
        result = this.incidentCategories.find(function (c) {
          return c.name == category;
        });
      }

      return result || unknownIncidentCategory;
    }
  }]);

  return Config;
}();

exports.Config = Config;
var unknownIncidentCategory = {
  name: "unknown",
  display: "Unknown",
  notificationName: "Unknown",
  imageUrl: null,
  backgroundColor: "#444964",
  backgroundGradientColors: ["#444964", "#444964"],
  order: 0,
  enabled: true
};

var AccessTokenImpl =
/*#__PURE__*/
function () {
  function AccessTokenImpl() {
    _classCallCheck(this, AccessTokenImpl);
  }

  _createClass(AccessTokenImpl, [{
    key: "isValid",
    get: function get() {
      if (this.access_token) {
        if (this.expires_at) {
          return this.expires_at > Date.now();
        } else {
          // if there is no expire time, the token is never expire
          return true;
        }
      }

      return false;
    }
  }]);

  return AccessTokenImpl;
}();

exports.AccessTokenImpl = AccessTokenImpl; // these keys have to match UserSettings

var UserSettingKey;

(function (UserSettingKey) {
  UserSettingKey["NotificationEnabled"] = "notificationEnabled";
  UserSettingKey["NotificationDistance"] = "notificationDistance";
})(UserSettingKey = exports.UserSettingKey || (exports.UserSettingKey = {})); // Incident Interfaces


var IncidentAction;

(function (IncidentAction) {
  IncidentAction["CallEmergency"] = "callEmergency";
  IncidentAction["AlertOrganization"] = "alertOrganization";
  IncidentAction["Publicize"] = "publicize";
  IncidentAction["AlertContacts"] = "alertContacts";
})(IncidentAction = exports.IncidentAction || (exports.IncidentAction = {}));

var IncidentNotificationTarget;

(function (IncidentNotificationTarget) {
  IncidentNotificationTarget["Contact"] = "contact";
  IncidentNotificationTarget["Organization"] = "organization";
  IncidentNotificationTarget["User"] = "user";
})(IncidentNotificationTarget = exports.IncidentNotificationTarget || (exports.IncidentNotificationTarget = {}));

var IncidentType;

(function (IncidentType) {
  IncidentType["Normal"] = "normal";
  IncidentType["Escort"] = "escort";
  IncidentType["PassiveEscort"] = "passiveEscort"; // Passive VE
})(IncidentType = exports.IncidentType || (exports.IncidentType = {}));

var HistoryType;

(function (HistoryType) {
  HistoryType["Note"] = "note";
  HistoryType["Chat"] = "chat";
  HistoryType["Message"] = "message";
  HistoryType["Incident"] = "incident";
  HistoryType["Escort"] = "escort";
  HistoryType["Video"] = "video";
  HistoryType["Share"] = "share";
  HistoryType["Close"] = "close";
  HistoryType["Comment"] = "comment";
})(HistoryType = exports.HistoryType || (exports.HistoryType = {}));

var ChatActionType;

(function (ChatActionType) {
  ChatActionType["Joined"] = "joined the chat";
  ChatActionType["Closed"] = "closed the chat";
})(ChatActionType = exports.ChatActionType || (exports.ChatActionType = {})); // Start used info from request from app during VE


var activityType;

(function (activityType) {
  activityType["Still"] = "still";
  activityType["Walking"] = "walking";
  activityType["OnFoot"] = "on_foot";
  activityType["Running"] = "running";
  activityType["OnBicycle"] = "on_bicycle";
  activityType["InVehicle"] = "in_vehicle";
  activityType["Unknown"] = "unknown";
})(activityType = exports.activityType || (exports.activityType = {}));

var motionEventType;

(function (motionEventType) {
  motionEventType["MotionChange"] = "motionchange";
  motionEventType["ProviderChange"] = "providerchange";
  motionEventType["Geofence"] = "geofence";
  motionEventType["HeartBeat"] = "heartbeat";
})(motionEventType = exports.motionEventType || (exports.motionEventType = {})); //end used info from request from app during VE


var IncidentEscortState;

(function (IncidentEscortState) {
  IncidentEscortState["Pending"] = "pending";
  IncidentEscortState["Active"] = "active";
  IncidentEscortState["Panic"] = "panic";
  IncidentEscortState["Background"] = "background";
  IncidentEscortState["Unknown"] = "unknown";
  IncidentEscortState["Closed"] = "closed";
  IncidentEscortState["Safe"] = "safe";
  IncidentEscortState["Expired"] = "expired";
  IncidentEscortState["Canceled"] = "canceled"; // canceled by client(Closed VE)
})(IncidentEscortState = exports.IncidentEscortState || (exports.IncidentEscortState = {}));

var MediaType;

(function (MediaType) {
  MediaType["Composition"] = "composition";
  MediaType["Record"] = "record";
})(MediaType = exports.MediaType || (exports.MediaType = {}));

var IncidentQueryTime;

(function (IncidentQueryTime) {
  IncidentQueryTime[IncidentQueryTime["Last2Hours"] = 0] = "Last2Hours";
  IncidentQueryTime[IncidentQueryTime["LastDay"] = 1] = "LastDay";
  IncidentQueryTime[IncidentQueryTime["LastWeek"] = 2] = "LastWeek";
  IncidentQueryTime[IncidentQueryTime["LastMonth"] = 3] = "LastMonth";
  IncidentQueryTime[IncidentQueryTime["All"] = 4] = "All";
})(IncidentQueryTime = exports.IncidentQueryTime || (exports.IncidentQueryTime = {}));

var PassiveEscortAction;

(function (PassiveEscortAction) {
  PassiveEscortAction["TimerStarted"] = "Timer Started";
  PassiveEscortAction["ProcedureAction"] = "Procedure Action";
  PassiveEscortAction["TimerExpired"] = "Timer Expired";
  PassiveEscortAction["PanicTriggered"] = "Panic Triggered";
  PassiveEscortAction["PanicExited"] = "Panic Exited";
  PassiveEscortAction["EscortComplete"] = "Escort Complete";
  PassiveEscortAction["IncidentCodeGenerated"] = "Code Generated";
  PassiveEscortAction["IncidentShared"] = "Incident Shared";
})(PassiveEscortAction = exports.PassiveEscortAction || (exports.PassiveEscortAction = {})); // Violation report


var ViolationType;

(function (ViolationType) {
  ViolationType["WrongContent"] = "wrongContent";
  ViolationType["NoContent"] = "noContent";
  ViolationType["Other"] = "other";
})(ViolationType = exports.ViolationType || (exports.ViolationType = {}));

var ViolationAction;

(function (ViolationAction) {
  ViolationAction["WrongAccuse"] = "wrongAccuse"; // remove flag
})(ViolationAction = exports.ViolationAction || (exports.ViolationAction = {}));

var NotificationType;

(function (NotificationType) {
  NotificationType["Incident"] = "incident";
  NotificationType["Escort"] = "escort";
  NotificationType["Message"] = "message";
  NotificationType["Panic"] = "panic";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));